<template>
  <div id="busqueda-administracion">
    <v-autocomplete
      :items="administraciones"
      dense
      clearable
      placeholder="Buscar una administración"
      no-data-text="No hay administraciones disponibles"
      v-model="administracion_seleccionada"
      prepend-inner-icon="search"
      :rules="reglas_administracion(administracion_seleccionada)"
      return-object
      @change="$emit('selecciono-administracion:actualizar', $event)"
      :item-text="(item) => `${item.nombre_con_id_formateado} - ${item.admin_ppal_mail}`"
      attach="#busqueda-administracion"
    >

      <template v-slot:selection="{ item }">
        <div class="v-select__selection v-select__selection--comma">
          {{ item ? item.nombre : '' }}
        </div>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item-content class="busqueda-administracion-item">
          <v-list-item-title>
            {{item.nombre_con_id_formateado}}
          </v-list-item-title>
          <v-list-item-subtitle v-if="item.admin_ppal_mail">
            {{ item.admin_ppal_mail }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { Administracion } from '@/models/Administracion';

/**
 * Componente para la busqueda de administraciones
 * 
 * Tiene dos (2) funcionalidades principales
 *  1. Permite dado un conjunto de administraciones por props, permite seleccionar una y emitir esa selección 
 *  2. En caso de proveerle ya una administración, esta se clonara y se mostrara preseleccionada
 * 
 * Este componente no tiene ninguna funcionalidad de busqueda, solo de seleccion
 */
export default {
  name:'BusquedaAdministracion',
  props:{
    administracion: { type: Administracion, default: null },
    administraciones: { type: Array, default: () => []},
  },
  data: () => ({
    administracion_seleccionada: null,

    reglas_administracion: (valor) => [!!valor || 'Debe seleccionar una administración'],
  }),
  watch:{
    /**
     * Emito la administración que selecciono
     */
    administracion_seleccionada(new_value){
      this.$emit('update:administracion', new_value);
    },
  },
  /**
   * Clono la administración cuando se monta, para tenerla seteada default
   */
  mounted(){
    this.administracion_seleccionada = _.cloneDeep(this.administracion);
  },
};
</script>

<style lang="scss">
#busqueda-administracion {

  .v-menu__content {
    left: 24px !important;
    top: 168px !important;
    min-width: 552px !important;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.25);
    margin-top: 10px;
    max-height:calc(100% - 260px) !important;
  }

  .busqueda-administracion-item {
    padding: 8.5px 0;

    .v-list-item__title {
      font-size: 15px;
      color: color(dark);
      margin-bottom: 4px;
    }

    .v-list-item__subtitle {
      font-size: 14px;
      color: color(gris);
    }

  }
}
</style>